import React from "react";
import {Box} from "@material-ui/core";
import {UploadFile} from "ts/api/chat";
import File from "./File";

type FilesProps = {
  files: UploadFile[];
  deleteFile: (id: string, fileName: string) => void;
  onResend?: (id: string, fileName: string) => void;
};

const Files = ({files, deleteFile, onResend}: FilesProps) => {
  if (!files?.length) {
    return null;
  }

  return (
    <Box width="100%" padding="8px" display="flex" flexWrap="wrap">
      {files.map((file) => {
        return (
          <File
            key={file.name}
            file={file}
            deleteFile={deleteFile}
            onResend={onResend}
          />
        );
      })}
    </Box>
  );
};

export default Files;
